export enum InAppFeedbackSteps {
  Rating = 'Rating',
  Sent = 'Sent',
  Article = 'Article',
}
